// extracted by mini-css-extract-plugin
export default {"background":"SubscribeModal_background__Wa5Oo","container":"SubscribeModal_container__SaBIK","text":"SubscribeModal_text__9l4Zj","link":"SubscribeModal_link__JV4qv"};